import { useTickerData } from '../hooks';
import './Ticker.css';

function StockItem({ stock }) {
  const pointChange = stock.price - stock.previousClose;
  const percentChange = (pointChange / stock.previousClose) * 100;
  const isUp = pointChange >= 0;
  const sign = isUp ? '+' : '';

  return (
    <div className={`stock ${isUp ? 'stock--up' : 'stock--down'}`}>
      <span className="stock__symbol">{stock.symbol}</span>
      <span className="stock__price">{stock.price.toFixed(2)}</span>
      <span className="stock__change">
        {isUp ? '▲' : '▼'} {sign}{pointChange.toFixed(2)} ({sign}{percentChange.toFixed(2)}%)
      </span>
    </div>
  );
}

function Ticker() {
  const { stocks, lastUpdated } = useTickerData();

  return (
    <section className="ticker" aria-label="Live stock ticker">
      <div className="ticker__status">
        <span className="ticker__live">
          <span className="ticker__dot" aria-hidden="true" />
          Live
        </span>
        <span className="ticker__updated">
          Updated{' '}
          {lastUpdated.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZoneName: 'short',
          })}
        </span>
      </div>
      <div className="ticker__viewport">
        <div className="ticker__track">
          {[0, 1].map((copy) => (
            <div className="ticker__row" key={copy} aria-hidden={copy === 1}>
              {stocks.map((stock) => (
                <StockItem key={`${copy}-${stock.symbol}`} stock={stock} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Ticker;
